// metadata/metaTree.ts
import { getTypeString } from "../baseqlTypes.js";
import { AdornisEntity } from "../entities/adornisEntity.js";
import { Tree } from "./tree.js";
var MetaTree = class extends Tree {
  getAllFields(node = this.root) {
    let fields = { ...node.fields };
    node.children.forEach(
      (child) => fields = {
        ...fields,
        ...this.getAllFields(child)
      }
    );
    return fields;
  }
  getAllNames(node, direction = 0) {
    const names = [getTypeString(node.type)];
    if (direction <= 0 && node.parent)
      names.unshift(...this.getAllNames(node.parent, -1));
    if (direction >= 0)
      node.children.forEach((child) => names.push(...this.getAllNames(child, 1)));
    return names;
  }
  resolveNode(input) {
    if (input instanceof AdornisEntity)
      input = input._class;
    if (typeof input === "function" && "_class" in input)
      input = input._class;
    if (typeof input === "string") {
      const toTest = input;
      const output = this.find((node) => getTypeString(node.type) === toTest);
      if (!output)
        throw new Error(`Could not resolve node from string ${input}`);
      return output;
    }
    if (typeof input === "function") {
      const toTest = input;
      const output = this.find((node) => node.type() === toTest());
      if (!output)
        throw new Error(`Could not resolve node from type function with type ${getTypeString(input)}`);
      return output;
    }
    return input;
  }
  validSubclasses(input) {
    const node = this.resolveNode(input);
    return this.reduce(
      (acc, node2) => {
        acc.push(node2.type()._class);
        return acc;
      },
      [],
      node
    );
  }
};
export {
  MetaTree
};
